import { RoutePlanner, RoutePlannerProps } from "@iventis/route-planner";
import React from "react";
import { useMapUndoRedoContext } from "./map-undo-redo-context";

/** Wrapper for route planner to access the undo redo context */
export const MapRoutePlanner: React.FC<RoutePlannerProps> = (props) => {
    const undoRedo = useMapUndoRedoContext();

    const wrappedProps = {
        ...props,
        operations: {
            // eslint-disable-next-line react/destructuring-assignment
            ...props.operations,
            convertToLine: () => {
                undoRedo.clear();
                return props.operations.convertToLine();
            },
        },
    };
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <RoutePlanner {...wrappedProps} />;
};
